<div class="save">

  <form [formGroup]="form" (submit)="handleSubmit()">

    <h1 mat-dialog-title>
      {{ dialogTitle }}
    </h1>

    <p *ngIf="settings.message" class="save__message">
      {{ settings.message }}
    </p>
      
    <div mat-dialog-content>
      <div class="theme-light">

        <!-- info -->
        <app-form-field theme="light" label="Title">
          <input class="input" type="text" name="title" maxlength="60" #title autocomplete="off" formControlName="title" required>
          <app-character-counter [field]="title"></app-character-counter>
          <mat-error *ngIf="!form.get('title').valid">Please enter a valid title.</mat-error>
        </app-form-field>

        <!-- only for group users -->
        <div *ngIf="organization$ | async">

          <!-- permission -->
          <app-form-field            
                *ngIf="isNew || isOwner"
                theme="light"
                label="Permissions">

                <mat-radio-group class="save__radio-group text-12 mt-2" formControlName="groupAccess">
                  <mat-radio-button value="" class="mb-2">Private</mat-radio-button>
                  <mat-radio-button value="view" class="mb-2">Team - View Only</mat-radio-button>
                  <mat-radio-button value="edit">Team - View & Edit</mat-radio-button>
                </mat-radio-group>

          </app-form-field>

          <!-- collection -->
          <app-form-field theme="light" *ngIf="(collections$ | async)?.length > 0" label="Collection (Optional)">

            <select class="input" formControlName="collection">
              <option [value]="null">--</option>
              <option *ngFor="let collection of collections$ | async" [value]="collection.collection_id">
                {{ collection.collection_name }}
              </option>
            </select>
            
          </app-form-field>

        </div>

        <!-- public bookmarks -->
        <div *ngIf="!(organization$ | async)">
           
          <app-form-field            
            theme="light"
            label="Share">
       
            <mat-checkbox class="save__permission" formControlName="publicAccess">
              <span class="text-12">With the BioDigital Community</span>
            </mat-checkbox>

          </app-form-field>
        </div>

      </div>

    </div>
      
    <!-- actions -->
    <div mat-dialog-actions>

      <button app-button buttonTheme="light" [mat-dialog-close] type="button" class="mr-2">Cancel</button>
      <button app-button buttonType="primary" cdkFocusInitial [disabled]="saving$ | async">
          {{ (saving$ | async) ? 'Saving' : 'Save' }}
          <app-spinner *ngIf="saving$ | async" size="medium" class="ml-2" render="inline"></app-spinner>
      </button>

    </div>

  </form>

</div>